export const getDisplayName = <T extends { firstName: string; lastName: string }>(user: T): string => {
  return `${user.firstName} ${user.lastName}`;
};
